import Cookie from 'js-cookie'
import { safeInvoke } from '~/utils/helper'

const cookie = {
  get value(): string|undefined {
    return Cookie.get('ref')
  },

  set value(value: string) {
    Cookie.set('ref', value, { expires: 7 })
  }
}

const url = new URL(window.location.href)

const ref = url.searchParams.get('ref')

if (ref && /^[0-9]{1,17}$/.test(ref)) {
  cookie.value = ref ? ref : ''
}


export const bind = (node: HTMLAnchorElement) => {
  const url = safeInvoke(() => new URL(node?.href ?? ''))

  if (!url || !node) return

  url.searchParams.set('ref', cookie.value ?? '')

  node.href = url.toString()
}

export const populate = (selectors: string[]) => {
  for (const item of selectors) {
    const node = document.querySelector<HTMLAnchorElement>(item)

    node && bind(node)
  }
}

export const populateAll = (selector: string) => {
  for (const node of document.querySelectorAll<HTMLAnchorElement>(selector)) {
    node && bind(node)
  }
}